export const WEEKLY = 'WEEKLY';
export const DAILY = 'DAILY';

export default [WEEKLY, DAILY];
